import { QueryObserverResult, useQuery } from '@tanstack/react-query';

import {
  API_QUERY_KEYS,
  getFilterCategories,
  GetFilterCategoriesResponse,
  QueryDefaults,
} from 'api';

export const useFilterCategories = (): QueryObserverResult<GetFilterCategoriesResponse> =>
  useQuery([API_QUERY_KEYS.getFilterCategories], getFilterCategories, QueryDefaults);
